/**
 * Unsaved inspection edits, cached in this browser for recovery during the
 * current login. Logout clears them with the rest of local storage. A new
 * inspection, not yet saved, is cached as `inspection-undefined`; the ink
 * draft page keeps its strokes in `draft-backup`.
 */
const DRAFT = /^(inspection-(\d+|undefined)|draft-backup)$/;

export const inspectionDraftKey = (inspectionId: string | number): string =>
  `inspection-${inspectionId}`;

/** Drops every cached draft, e.g. when another account signs in. */
export function dropInspectionDrafts(): void {
  for (const key of Object.keys(localStorage)) {
    if (DRAFT.test(key)) {
      localStorage.removeItem(key);
    }
  }
}
